export default __webpack_public_path__ + "images/Transthalamic_View.9282a9403645ff1286910090d43e4b8c.png";